import { setupLocalStorageGuard } from './utils/localStorageGuard'
setupLocalStorageGuard()

if (process.env.NODE_ENV !== 'local' && !localStorage.getItem('forceLogs')) {
  console.log = () => {}
  console.debug = () => {}
  console.info = () => {}
}

import Vue from 'vue'
import Vuesax from 'vuesax'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VeeValidate_messages_en from 'vee-validate/dist/locale/en'
import VeeValidate_messages_fr from 'vee-validate/dist/locale/fr'
import PortalVue from 'portal-vue'


import App from './App.vue'

import router from './router'
import messages from './locales'

import store from './store/index'
import i18nDebug, { translationMap } from './plugins/i18nDebug'

import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css'
import 'vue2-timepicker/dist/VueTimepicker.css'
import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag'

import contenteditable from 'vue-contenteditable'
Vue.use(contenteditable)



import GoogleAuth from 'vue-google-oauth2'
import './registerServiceWorker'
const gauthOption = {
  clientId: '449216615581-rbtg6qp7g5ctaj1nbotj04ch677ab6kc.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/business.manage',
  access_type: 'offline',
  prompt: 'consent'
}
Vue.use(GoogleAuth, gauthOption)

// prod : redirect to saas.mashup-web.com
if (process.env.NODE_ENV == 'production' && window.location.href.includes('beta.saas'))
  window.location.href = window.location.href.replace('beta.saas', 'saas')

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#2f1937',
      success: '#b44884',
      danger: 'rgb(242, 19, 93)',
      warning: '#2f1937',
      dark: '#2f1937'
    }
  }
})

Vue.use(VueAnalytics, {
  //id: 'UA-88262954-6',
  id: 'UA-111283719-1',
  autoTracking: {
    pageviewOnLoad: true
  }
})

Vue.use(VueGtag, {
  config: { id: 'G-GVGE5F773F' }
}, router)

Vue.use(VueI18n)
Vue.use(VueResource)


import TokenPlugin from './plugins/conciergerieTokenPlugin'
Vue.use(TokenPlugin, { store })

import axios from 'axios'
import { initAxios } from '@mashupweb/draft-lib/utils/http'

const axiosInstance = axios.create()
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})
initAxios(axiosInstance)

Vue.use(VeeValidate, {
  dictionary: {
    en: VeeValidate_messages_en,
    fr: VeeValidate_messages_fr
  }
})

Vue.use(PortalVue)
Vue.use(i18nDebug)

//use EN messages if locale is empty
Object.keys(messages).forEach(l => {
  Object.keys(messages[l]).forEach(k => {
    if (messages[l][k] == '')
      messages[l][k] = messages['en'][k]
  })
})

const i18n = new VueI18n({
  locale: localStorage.getItem('language')
    || navigator.languages.find((l) => l.length == 2)
    || navigator.language.split('-')[0]
    || 'fr',
  messages,
  postTranslation: localStorage.getItem('adminTraduction') === 'true'
    ? (str, key) => { const t = str?.toString?.()?.trim(); if (t) translationMap.set(t, key); return str }
    : undefined
})

Object.defineProperty(Vue.prototype, '$globals', {
  value: {},
  writable: false
})

new Vue({
  i18n,
  router,
  render: h => h(App),
  store,
}).$mount('#app')
